import type { Bonus, PreviewPage, Volume } from '../types/content';
export const capabilities = ['Identificar qué necesitás en cada momento', 'Encontrar rápidamente una práctica adecuada', 'Seguir rutinas ya preparadas sin tener que crearlas'];
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'EL MAPA DEL AUTOCUIDADO',
  subtitle: 'Encontrá rápidamente qué necesitás y por dónde empezar.',
  items: ['Identificás qué necesitás según tu situación', 'Te orientás entre las 5 áreas del sistema', 'Encontrás rápidamente qué práctica utilizar'],
  result: '“Sé por dónde empezar.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'MANUAL DE PROTOCOLOS DE BIENESTAR',
  subtitle: 'Tené prácticas completas para seguir sin organizarlas desde cero.',
  items: ['Sabés qué necesitás antes de comenzar', 'Seguís instrucciones paso a paso', 'Tenés alternativas según el momento'],
  result: '“Sé exactamente qué hacer.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'BOTIQUÍN NATURAL DE AUTOCUIDADO',
  subtitle: 'Organizá los recursos naturales que pueden acompañar tus momentos de bienestar.',
  items: ['Conocés hierbas, infusiones y aromas', 'Encontrás formas prácticas de utilizarlos', 'Tenés alternativas y precauciones importantes'],
  result: '“Tengo mis recursos preparados.”',
  accent: 'highlight'
}, {
  label: 'VOLUMEN 04',
  title: 'MANUAL DE RUTINAS DE BIENESTAR',
  subtitle: 'Convertí prácticas individuales en rutinas completas y fáciles de seguir.',
  items: ['Tenés rutinas para mañana, tarde y noche', 'Elegís opciones de 5, 10, 15 o 20 minutos', 'Accedés a planes semanales ya preparados'],
  result: '“Tengo una rutina lista para seguir.”',
  accent: 'danger'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/36FzUN72ABvXtCWVqCFT4v/Hoja_1.webp',
  alt: 'Página del sistema: Todo el sistema en un solo mapa.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dhXPRLsu6ZwhQvmQF3L9LD/Hoja_2.webp',
  alt: 'Página del sistema: 02 — Descansar, prácticas para preparar el momento de descanso.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/b72bM7Zn2q8eQJMfhz49xv/Hoja_3.webp',
  alt: 'Página del sistema: Elegí según el momento del día.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rKqLYFr58wJUuwaHLtVAST/Hoja_4.webp',
  alt: 'Página del sistema: Tené esto a mano — básico, útil y opcional.'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'RADAR DEL BIENESTAR™',
  detail: 'Una herramienta para encontrar rápidamente qué utilizar según lo que necesitás.',
  items: ['Partís de una situación concreta', 'Identificás el área relacionada', 'Encontrás la práctica adecuada'],
  value: '$12.000'
}, {
  number: '02',
  title: 'RUTA DE INICIO™',
  detail: 'Un recorrido preparado para comenzar a utilizar el sistema sin complicarte.',
  items: ['Sabés qué hacer primero', 'Seguís un recorrido paso a paso', 'Empezás sin diseñar tu propia rutina'],
  value: '$10.000'
}, {
  number: '03',
  title: 'KIT TODO LISTO™',
  detail: 'Organizá los elementos que pueden acompañar tus momentos de autocuidado.',
  items: ['Sabés qué elementos tener disponibles', 'Organizás tus recursos en un solo lugar', 'Preparás kits para diferentes momentos'],
  value: '$9.000'
}, {
  number: '04',
  title: 'SEMANA EN CALMA™',
  detail: 'Una semana completa de autocuidado ya preparada para vos.',
  items: ['Tenés una propuesta organizada para 7 días', 'Cada día incluye una práctica concreta', 'Evitás decidir qué hacer cada día'],
  value: '$11.000'
}, {
  number: '05',
  title: 'PAUSA 15™',
  detail: 'Prácticas preparadas para esos momentos en los que tenés poco tiempo.',
  items: ['Encontrás opciones de 5 minutos', 'Tenés alternativas de 10 minutos', 'Elegís según el tiempo disponible'],
  value: '$10.000'
}];
